import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'pr-input-radio-round',
    templateUrl: './pr-input-radio-round.component.html',
    styleUrls: ['./pr-input-radio-round.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputRadioRoundComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PrInputRadioRoundComponent,
        },
    ],
    standalone: false
})
export class PrInputRadioRoundComponent
  implements ControlValueAccessor, Validator
{
  @ViewChild('input', { static: true }) inputRef: ElementRef;
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  @Input() disable: boolean = false;
  @Output() onCheck: EventEmitter<any> = new EventEmitter();
  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  value;
  date: string = null;
  touched = false;
  onChange = val => {};
  onTouched = () => {};

  @Input() options = [
    { value: true, label: 'Oui', icon: undefined },
    { value: false, label: 'Non', icon: undefined },
  ];

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {
    if (this.control) this.value = this.control.value;
    else this.value = this.options[1].value;
  }

  checked(option) {
    return this.value == option.value;
  }

  get formLabel() {
    return `${this.formControlName}_${this.hash}`;
  }

  onInputChange($event, option) {
    this.onCheck.emit(option.value);
    this.value = option.value;
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
